import products from "../../Categorie";

// `images` is a string for most products and a one-item array for a few.
export const toImage = (images) => (Array.isArray(images) ? images[0] : images);
export const toImages = (images) => [].concat(images).filter(Boolean);

export const hasImage = (image) => Boolean(image) && image !== "url_interdite";

// Case- and accent-insensitive text used for the search boxes.
export const normalize = (text) =>
  String(text)
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase();

export function findSubCategory(idcode) {
  for (const category of products) {
    for (const sub of category.souscategories) {
      if (String(sub.idcode) === String(idcode)) return { category, sub };
    }
  }
  return null;
}

export function findProduct(id) {
  for (const category of products) {
    for (const sub of category.souscategories) {
      for (const product of sub.produits || []) {
        if (product.id === id) return { category, sub, product };
      }
    }
  }
  return null;
}
